import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { PageHeaderURL } from './page-header-url.config';

@Injectable({
  providedIn: 'root'
})
export class PageHeaderService {
  constructor(private httpService: HttpService) {
     // This is intentional
  }

  getAuthorizedPages(orgid) {
    return this.httpService.get(PageHeaderURL.EndPoints.page.getAuthorizedPages.replace('{orgid}', orgid));
  }
}
